import BlogIndex from "~/components/BlogIndex";
import { getBlogIndexPaths, getBlogIndexProps } from "~/lib/blog-index";

export async function getStaticPaths() {
  return getBlogIndexPaths({ byCategory: true, paged: false });
}

export async function getStaticProps({ params }) {
  return getBlogIndexProps({ params });
}

export default BlogIndex;
